import { defineStore } from "pinia";
import { commClient } from "fw4-library";
import router from "@app/router";
import { IKeyValue, IUser, useAppStore } from "@appstore/store";

interface ITrainingsStore {
    Sklopi: ITrainingPart[]
    CurrentSklop: ITrainingPart | undefined,
    CurrentVprasanjeId: number,
    VprasanjeLoaded: boolean
}

export interface ITrainingPart {
    SklopId: number;
    Name: string;
    Description: string;
    Created: Date;
    DateCompleted: Date;
    Successful: boolean;
    IsObligatory: boolean;
    StVprasanj: number;
    ZakljucenihVprasanj: number;
    Vprasanja: ITrainingQuestion[] | undefined;
}

export interface ITrainingQuestion {
    VprasanjeId: number,
    Subject: string,
    Content: string,
    ValidationError: string | undefined,
    Odgovori: ITrainingAnswer[]
}

export interface ITrainingAnswer {
    OdgovorId: number,
    IsCorrect: boolean,
    IsSelected: boolean,
    Content: string
}

export const useTrainingStore = defineStore("trainingStore", {
    state: (): ITrainingsStore => {
        return {
            Sklopi: [],
            CurrentSklop: undefined,
            CurrentVprasanjeId: -1,
            VprasanjeLoaded: false
        };
    },

    actions: {
        async loadTrainings() {
            const loadCodeComplete = (Message: any): void => {
                if (Message) {  
                    this.Sklopi = Message;
                } else {
                }
            };

            commClient.executeMethod("sf.IzobrazevanjaLoad", {}, loadCodeComplete);
        },

        async loadSpecificTraining(sklopIdx: number) {
            const loadCodeComplete = (Message: any): void => {
                if (Message) {  
                    this.CurrentSklop = Message;
                    this.VprasanjeLoaded = true;
                } else {
                }
            };

            commClient.executeMethod("sf.IzobrazevanjeSpecificLoad", {
                SklopId: this.Sklopi[sklopIdx].SklopId
            }, loadCodeComplete);
        },

        clearQuestionValidationError() {
            this.currentVprasanje.ValidationError = undefined;
        },

        nextQuestion() {
            // check if all ok
            let selectedQuestions: number = 0;
            this.currentVprasanje.Odgovori.forEach(element => {
               if (element.IsSelected) 
               {
                    selectedQuestions++;
                    this.scrollToTop();
               }
            });
            if (selectedQuestions > 0) {
                this.CurrentVprasanjeId++;
            } else {
                this.currentVprasanje.ValidationError = "Izbrati morate vsaj en odgovor.";
            }
        },

        prevQuestion() {
            this.CurrentVprasanjeId--;
            this.scrollToTop();
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        complete() {
            // check if all ok
            let selectedQuestions: number = 0;
            this.currentVprasanje.Odgovori.forEach(element => {
               if (element.IsSelected) 
               {
                    selectedQuestions++;
               }
            });
            if (selectedQuestions > 0) {
                const saveComplete = (Message: any): void => {
                    router.push({name: "training_complete"});
                };
    
                commClient.executeMethod("sf.IzobrazevanjeSave", {
                    SklopId: this.CurrentSklop!.SklopId,
                    VprasanjaData: JSON.stringify(this.currentSklopValueData)
                }, saveComplete);
            } else {
                this.currentVprasanje.ValidationError = "Izbrati morate vsaj en odgovor.";
            }
        },

        async loadTrainingComplete() {
            const appStore = useAppStore();

            const loadUserComplete = (Message: any): void => {
                if (Message) {
                    appStore.User = Message as IUser;
                }
            };

            const loadComplete = (Message: any): void => {
                this.CurrentSklop!.Successful = Message[0].Opravil;
                commClient.executeMethod("sf.AppDataLoad", {}, loadUserComplete);
            };

            commClient.executeMethod("sf.IzobrazevanjeComplete", {
                SklopId: this.CurrentSklop!.SklopId
            }, loadComplete);
        },
        
        async saveTraining() {
            // check if all ok
            let selectedQuestions: number = 0;
            this.currentVprasanje.Odgovori.forEach(element => {
               if (element.IsSelected) 
               {
                    selectedQuestions++;
               }
            });
            if (selectedQuestions > 0) {
                const saveComplete = (Message: any): void => {
                    router.push({name: "trainings"})
                };
    
                commClient.executeMethod("sf.IzobrazevanjeSave", {
                    SklopId: this.CurrentSklop!.SklopId,
                    VprasanjaData: JSON.stringify(this.currentSklopValueData)
                }, saveComplete);
            } else {
                this.currentVprasanje.ValidationError = "Izbrati morate vsaj en odgovor.";
            }
        },
    },

    getters: {
        currentVprasanje: (state) => {
            return state.CurrentSklop!.Vprasanja![state.CurrentVprasanjeId]!;
        },

        currentSklopValueData: (state) => {
            let retVprasanje: IKeyValue[] = [];
            if (state.CurrentSklop != undefined && state.CurrentSklop.Vprasanja != undefined) {
                state.CurrentSklop!.Vprasanja!.forEach(vprasanje => {
                    if (vprasanje.Odgovori != undefined) {
                        vprasanje.Odgovori.forEach(odgovor => {
                            if (odgovor.IsSelected) {
                                retVprasanje.push({
                                    "Key": odgovor.OdgovorId,
                                    "Value": "1"
                                });
                            }
                        });    
                    }
                });    
            }
            return retVprasanje;
        },

    }
});
